// EN
export const accomMgmt = {
  common: {
    cancel: "Anuluj",
    save: "Zapisz",
    update: "Aktualizuj",
    back: "Wstecz",
    continue: "Dalej",
    optional: "(opcjonalnie)",
    optionalPlaceholder: "Opcjonalnie",
    processing: "Przetwarzanie...",
    name: "Nazwa",
    description: "Opis",
    nameRequired: "Nazwa jest wymagana.",
  },

  type: {
    apartment: "Apartament turystyczny",
    hotel: "Hotel",
    camping: "Kemping",
    villa: "Willa",
  },

  step: {
    type: "Typ",
    structure: "Struktura",
    accommodation: "Obiekt",
  },

  step1: {
    title: "Jaki to typ obiektu?",
    subtitle: "Proszę wybrać typ obiektu.",
    subtitleQuota: "Aktywne będą tylko te typy, na które został limit w planie.",
    subtitleFirst: "To pierwszy obiekt, więc można wybrać dowolny typ.",
    remaining: "pozostało: {count}",
    loadingQuota: "Wczytywanie limitu planu…",
  },

  step2: {
    title: "Konfiguracja obiektu",
    subtitle:
      "Proszę zdecydować, czy będzie to obiekt samodzielny, czy z wieloma kalendarzami (kilka jednostek w ramach jednego obiektu).",
    singleTitle: "Jedna przestrzeń",
    singleChip: "1 kalendarz",
    singleDesc: "Wynajem całego apartamentu na jednym kalendarzu.",
    groupedTitle: "Wiele przestrzeni",
    groupedChip: "Wiele kalendarzy",
    groupedDesc: "Wynajem kilku niezależnych przestrzeni w ramach apartamentu",
  },

  step3: {
    title: "Konfiguracja obiektu głównego",
    subtitle:
      "Będzie to „kontener” (Oferta), który grupuje kilka kalendarzy. Np. „Apartament Zamkowy”.",
    panelTitle: "Proszę wybrać opcję",
    availableCount: "Dostępnych obiektów zgrupowanych: {count}.",
    noneAvailable: "Brak dostępnych ofert zgrupowanych dla tego typu (trzeba utworzyć nową).",
    newTitle: "Utwórz nowy obiekt główny",
    newDesc: "Nazwę obiektu głównego ustala użytkownik.",
    nameLabel: "Nazwa obiektu głównego",
    namePlaceholder: "Np. Apartament Zamkowy",
    nameHelp: "Ta nazwa zostanie zapisana i pozwoli zgrupować kilka kalendarzy.",
    minChars: "Proszę wpisać co najmniej 3 znaki.",
    existingTitle: "Dodaj do istniejącego obiektu",
    existingDesc: "Jednostka znajdzie się w już utworzonym obiekcie.",
    selectLabel: "Proszę wybrać obiekt",
    selectPlaceholder: "Wybierz obiekt…",
    listingOption: "{name} · jednostek: {units}",
    ready: "Gotowe",
    noneForType: "Brak dostępnych obiektów zgrupowanych dla tego typu.",
    tip: "Wskazówka: ten obiekt „główny” będzie kontenerem, do którego trafi nowa jednostka.",
  },

  preview: {
    tab: "mojobiekt",
    perNight: "/noc",
    book: "Zarezerwuj",
    locationPlaceholder: "Kraj, miasto, ulica",
    guests: "{count} gość | {count} goście | {count} gości",
    bedrooms: "{count} sypialnia | {count} sypialnie | {count} sypialni",
    bathrooms: "{count} łazienka | {count} łazienki | {count} łazienek",
    amenitiesTitle: "Udogodnienia",
    amenitiesEmpty: "Proszę wybrać, aby dodać udogodnienia do obiektu",
    locationTitle: "Lokalizacja",
    locationEmpty: "Proszę ustawić lokalizację",
    descriptionTitle: "Opis",
    descriptionEmpty: "Proszę wybrać, aby dodać opis obiektu",
    namePlaceholder: "Nazwa obiektu",
    amenity: {
      air_conditioning: "Klimatyzacja",
      heating: "Ogrzewanie centralne",
      parking: "Miejsce parkingowe",
      oven: "Piekarnik i płyta",
      pets_allowed: "Zwierzęta dozwolone",
      wifi: "Internet WiFi",
      essentials: "Podstawowe wyposażenie",
      washing_machine: "Pralka",
      children_allowed: "Dzieci dozwolone",
      refrigerator: "Lodówka",
    },
  },

  amenities: {
    title: "Wyposażenie i udogodnienia",
    subtitle: "Warto pokazać gościom, co oferuje obiekt, aby wiedzieli, czego się spodziewać.",
    searchPlaceholder: "Szukaj udogodnienia…",
    selectedCount:
      "{count} wybrane udogodnienie | {count} wybrane udogodnienia | {count} wybranych udogodnień",
    noResults: 'Nie znaleziono udogodnień dla „{search}”.',
    cat: {
      all: "Wszystkie",
      basics: "Podstawy",
      bathroom: "Łazienka",
      bedroom: "Sypialnia i pranie",
      kitchen: "Kuchnia i jadalnia",
      outdoor: "Na zewnątrz",
      leisure: "Wypoczynek i rozrywka",
      safety: "Bezpieczeństwo",
      family: "Rodziny",
      parking: "Parking",
      services: "Usługi",
      connectivity: "Łączność",
      accessibility: "Dostępność",
    },
    item: {
      wifi: "WiFi",
      essentials: "Podstawowe wyposażenie",
      air_conditioning: "Klimatyzacja",
      heating: "Ogrzewanie",
      indoor_fireplace: "Kominek wewnętrzny",
      hot_water: "Ciepła woda",
      hangers: "Wieszaki",
      bed_linen: "Pościel",
      towels: "Ręczniki",
      shampoo: "Szampon",
      shower_gel: "Żel pod prysznic",
      conditioner: "Odżywka do włosów",
      hair_dryer: "Suszarka do włosów",
      bathtub: "Wanna",
      bidet: "Bidet",
      jacuzzi: "Jacuzzi",
      outdoor_shower: "Prysznic zewnętrzny",
      washing_machine: "Pralka",
      dryer: "Suszarka do ubrań",
      iron: "Żelazko",
      clothes_drying_rack: "Suszarka na pranie",
      extra_pillows: "Dodatkowe poduszki i koce",
      wardrobe: "Miejsce na ubrania",
      blackout_curtains: "Rolety lub zasłony zaciemniające",
      nearby_laundry: "Pralnia w pobliżu",
      oven: "Piekarnik",
      refrigerator: "Lodówka",
      freezer: "Zamrażarka",
      microwave: "Mikrofalówka",
      dishwasher: "Zmywarka",
      cooking_basics: "Podstawowe przybory kuchenne",
      plates_cutlery: "Naczynia i sztućce",
      wine_glasses: "Kieliszki do wina",
      coffee_maker: "Ekspres do kawy",
      coffee: "Kawa",
      kettle: "Czajnik",
      toaster: "Toster",
      blender: "Blender",
      rice_cooker: "Urządzenie do gotowania ryżu",
      bread_maker: "Automat do chleba",
      mini_fridge: "Mała lodówka",
      stovetop: "Płyta kuchenna",
      dining_table: "Stół jadalny",
      baking_sheet: "Blacha do pieczenia",
      bbq_grill: "Grill",
      bbq_utensils: "Przybory do grilla",
      outdoor_kitchen: "Kuchnia zewnętrzna",
      outdoor_dining: "Jadalnia na zewnątrz",
      breakfast: "Śniadanie",
      pool: "Basen",
      shared_pool: "Basen wspólny",
      garden: "Ogród",
      patio_balcony: "Patio lub balkon",
      outdoor_furniture: "Meble ogrodowe",
      sun_loungers: "Leżaki",
      hammock: "Hamak",
      fire_pit: "Palenisko na zewnątrz",
      shared_fireplace: "Kominek we wspólnej strefie",
      sauna: "Sauna",
      beach_essentials: "Wyposażenie plażowe",
      beach_access: "Dostęp do plaży",
      lake_access: "Dostęp do jeziora",
      resort_access: "Dostęp do ośrodka",
      waterfront: "Nad samą wodą",
      dock: "Pomost dla łodzi",
      kayak: "Kajak",
      bikes: "Rowery",
      ski_slope: "Stok narciarski",
      outdoor_playground: "Plac zabaw na zewnątrz",
      tv: "Telewizor",
      sound_system: "System audio",
      record_player: "Gramofon",
      piano: "Pianino",
      gym: "Siłownia",
      exercise_equipment: "Sprzęt do ćwiczeń",
      games: "Gry planszowe",
      giant_games: "Gry wielkoformatowe",
      pool_table: "Stół bilardowy",
      ping_pong: "Stół do ping-ponga",
      bowling: "Kręgielnia",
      arcade: "Automaty do gier",
      minigolf: "Minigolf",
      batting_cage: "Klatka treningowa do baseballu",
      ice_rink: "Lodowisko do hokeja",
      laser_tag: "Laser tag",
      skate_ramp: "Rampa do deskorolki",
      climbing_wall: "Ścianka wspinaczkowa",
      game_console: "Konsola do gier",
      books: "Książki i lektury",
      cinema: "Kino",
      themed_room: "Pokój tematyczny",
      smoke_detector: "Czujnik dymu",
      co_detector: "Czujnik tlenku węgla",
      fire_extinguisher: "Gaśnica",
      first_aid_kit: "Apteczka",
      fire_guard: "Osłona kominka",
      safe: "Sejf",
      gated_community: "Osiedle zamknięte",
      security_cameras: "Kamery monitoringu",
      children_allowed: "Dzieci dozwolone",
      crib: "Łóżeczko dziecięce",
      travel_cot: "Łóżeczko turystyczne",
      baby_bath: "Wanienka dla niemowląt",
      baby_safety_gates: "Bramki zabezpieczające",
      changing_table: "Przewijak",
      high_chair: "Krzesełko do karmienia",
      children_plates: "Naczynia i sztućce dla dzieci",
      children_books_toys: "Książki i zabawki dla dzieci",
      kids_bikes: "Rowerki dla dzieci",
      outlet_covers: "Zaślepki do gniazdek",
      table_corner_guards: "Osłony na rogi stołu",
      window_guards: "Zabezpieczenia okien",
      baby_monitor: "Niania elektroniczna",
      children_game_room: "Pokój zabaw dla dzieci",
      babysitter_recommendations: "Polecane opiekunki",
      parking: "Bezpłatny parking na terenie obiektu",
      free_street_parking: "Bezpłatny parking na ulicy",
      paid_parking_on_premises: "Płatny parking na terenie obiektu",
      paid_parking_off_premises: "Płatny parking poza obiektem",
      ev_charger: "Ładowarka do samochodów elektrycznych",
      e_bike_charger: "Ładowarka do rowerów elektrycznych",
      pets_allowed: "Zwierzęta dozwolone",
      long_term_stays: "Możliwość długich pobytów",
      luggage_dropoff: "Możliwość zostawienia bagażu",
      cleaning_during_stay: "Sprzątanie w trakcie pobytu",
      concierge: "Konsjerż",
      cleaning_products: "Środki czystości",
      recycling: "Pojemniki do segregacji",
      compactor: "Zgniatarka do odpadów",
      compost: "Kompostownik",
      solar_panels: "Panele słoneczne",
      workspace: "Miejsce do pracy",
      private_entrance: "Osobne wejście",
      private_lounge: "Prywatny salon",
      mosquito_net: "Moskitiera",
      ceiling_fan: "Wentylator sufitowy",
      portable_fans: "Wentylatory przenośne",
      ethernet: "Połączenie Ethernet",
      mobile_wifi: "Mobilne WiFi",
      single_floor: "Obiekt na jednym poziomie",
      elevator: "Winda",
    },
  },

  room: {
    createTitle: "Zarejestruj typ pokoju",
    editTitle: "Aktualizuj typ pokoju",
    namePlaceholder: "Np. Pokój dwuosobowy",
    countLabel: "Liczba pokoi tego typu",
    countPlaceholder: "Np. 20",
    countHint: "To łączny zasób dla danego typu. Np. „Dwuosobowy” = 20 pokoi.",
    capacityLabel: "Całkowita pojemność (maks. gości)",
    capacityPlaceholder: "Np. 5",
    capacityHint:
      "To rzeczywisty limit gości. Nawet przy ustawionych maksimach na kategorię decyduje wartość całkowita.",
    maxAdults: "Maks. dorosłych",
    maxChildren: "Maks. dzieci",
    maxInfants: "Maks. niemowląt",
    importantLabel: "Ważne:",
    capacityNote: "to limity na kategorię. Łączną dopuszczalną liczbę ustala „Całkowita pojemność”.",
    physicalTitle: "Pokoje fizyczne (RoomInstances)",
    physicalDesc: "Opcja przydatna do zarządzania numerami 101/102, konserwacją i zamkami w poszczególnych pokojach.",
    generateLabel: "Generuj/dostosuj pokoje fizyczne automatycznie",
    generatorTitle: "Generator kodów",
    prefixLabel: "Prefiks",
    prefixPlaceholder: "Np. 10 albo A-",
    prefixHint: "Np. prefiks „10” + start 1 => 101,102...",
    startLabel: "Start",
    paddingLabel: "Dopełnienie",
    paddingHint: "Np. dopełnienie 3 => 001,002,003",
    nameModeType: "Tylko typ",
    nameModeTypeCode: "Typ + kod",
    defaultDescLabel: "Opis domyślny",
    willCreatePre: "Maksymalnie",
    willCreatePost: "pokoi fizycznych zostanie utworzonych lub dostosowanych automatycznie.",
    errors: {
      saveFallback: "Błąd podczas zapisywania typu pokoju.",
      capacityMin: "Całkowita pojemność musi wynosić co najmniej 1.",
      adultsMin: "Musi być dozwolona co najmniej 1 osoba dorosła.",
      adultsMax: "Limit osób dorosłych nie może przekraczać całkowitej pojemności.",
      childrenRange: "Limit dzieci musi mieścić się między 0 a całkowitą pojemnością.",
      infantsRange: "Limit niemowląt musi mieścić się między 0 a całkowitą pojemnością.",
      roomsMin: "Liczba pokoi musi wynosić co najmniej 1.",
      notAuth: "Użytkownik nieuwierzytelniony.",
    },
    toasts: {
      updated: "Typ zaktualizowany.",
      created: "Typ utworzony.",
      roomsSynced: "Pokoje fizyczne wygenerowane/dostosowane pomyślnie.",
    },
  },

  rate: {
    registerHeader: "Zarejestruj typ pokoju",
    editHeader: "Aktualizuj stawkę - {name}",
    createHeader: "Zarejestruj stawkę - {name}",
    processing: "Przetwarzanie, proszę czekać.",
    general: "Ogólne",
    namePlaceholder: "Nazwa własna",
    validityLabel: "Okres obowiązywania",
    permanent: "Stała",
    custom: "Własny",
    startDatePlaceholder: "Data początkowa",
    endDatePlaceholder: "Data końcowa",
    validityNoteCustom: "Okres obowiązywania stawki (opcjonalnie)",
    validityNotePermanent: "Stawka obowiązuje bezterminowo",
    pricePerNight: "Cena za noc",
    taxIncluded: "Podatki wliczone",
    occupancy: "Obłożenie",
    guestsNumber: "Liczba gości",
    minStay: "Pobyt minimalny",
    minStayNote: "Minimalna liczba nocy do rozliczenia",
    maxStay: "Pobyt maksymalny",
    maxStayNote: "Limit nocy w rezerwacji",
    errors: {
      rangeRequired: "Trzeba wybrać prawidłowy zakres dat",
      startAfterEnd: "Data początkowa nie może być późniejsza niż data końcowa",
      minStay:
        "Pobyt minimalny to {minStay} nocy, a wybrany zakres ma {nights} nocy",
    },
  },
};
